<template>
  <div
    class="upload-status-chip d-flex align-center pl-3"
    :class="color"
  >
    <v-icon class="mr-1" color="white">{{ icon }}</v-icon>
    <span class="text-body-2 font-weight-bold white--text">
      {{ text }}
    </span>
  </div>
</template>

<script>
import { ReferenceFile } from '@/models';
import { typeHelpers } from '@/modules';

const State = {
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  SOME_FAILED: 'SOME_FAILED',
  ALL_FAILED: 'ALL_FAILED',
};

const STATE_TO_PROPS = {
  [State.COMPLETE]: {
    icon: 'check',
    color: 'success',
    text: 'Complete',
  },
  [State.IN_PROGRESS]: {
    icon: 'sync',
    color: 'info',
    text: 'In Progress',
  },
  [State.SOME_FAILED]: {
    icon: 'check',
    color: 'warning',
    text: 'Some Failed',
  },
  [State.ALL_FAILED]: {
    icon: 'error',
    color: 'error',
    text: 'Failed',
  },
};

export default {
  name: 'UploadStatusChip',
  props: {
    referenceFiles: {
      type: Array,
      default: () => [],
      validator: typeHelpers.isArrayOfType(ReferenceFile),
    },
  },
  computed: {
    icon() {
      return STATE_TO_PROPS[this.state].icon;
    },
    color() {
      return STATE_TO_PROPS[this.state].color;
    },
    text() {
      return STATE_TO_PROPS[this.state].text;
    },
    state() {
      if (
        this.referenceFiles.every((referenceFile) =>
          referenceFile.success()
        )
      ) {
        return State.COMPLETE;
      } else if (
        this.referenceFiles.some((referenceFile) =>
          referenceFile.inProgress()
        )
      ) {
        return State.IN_PROGRESS;
      } else if (
        this.referenceFiles.every((referenceFile) =>
          referenceFile.failed()
        )
      ) {
        return State.ALL_FAILED;
      } else {
        return State.SOME_FAILED;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$upload-status-chip-width: 132px;
$upload-status-chip-height: 32px;

.upload-status-chip {
  border-radius: $upload-status-chip-height;
  width: $upload-status-chip-width;
  height: $upload-status-chip-height;
}
</style>
